import React from 'react';
import moment from 'moment';
import { fetchSameOrigin, camelizeKeys } from '../Utils';

const createNote = (memberId, note) => {
  const url = '/timeline_notes';
  return fetchSameOrigin(url, 'POST', { body: JSON.stringify({
    related_entity_type: 'Member',
    related_entity_id: memberId,
    note: note,
    note_date: moment().toDate(),
  })}).then(r => r.json()).then( ({ error, timeline_note }) => {
    const {note, note_date, author} = timeline_note;
    return new Promise((resolve) => {
      resolve({
        error: !!error && !!error.length && (<ul>{error.map(e => <li>{e}</li>)}</ul>),
        note: camelizeKeys({note, note_date, author})
      });
    })
  })
};
window.createNote = createNote;

export default createNote;
